import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. El sistema está explicado desde cero.'
  }, {
    q: '¿Necesito máquinas especiales?',
    a: 'No. Podés empezar con herramientas básicas y materiales económicos.'
  }, {
    q: '¿Cuánto dinero necesito para arrancar?',
    a: 'Muy poco. Con una inversión mínima ya podés fabricar tus primeros productos.'
  }, {
    q: '¿Puedo vender aunque tenga pocos seguidores?',
    a: 'Sí. El sistema incluye estrategias simples para conseguir tus primeras ventas.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Accedés inmediatamente después del pago desde tu celular o computadora.'
  }, {
    q: '¿Y si no me sirve?',
    a: 'Tenés garantía total de 7 días.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 px-4 bg-white" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <div className="text-center mb-5" data-id="element-72">
          <div className="inline-flex items-center gap-2 bg-slate-100 text-slate-700 px-3 py-1 rounded-full font-bold text-xs mb-2" data-id="element-73">
            <HelpOutlineIcon fontSize="small" data-id="element-74" /> DUDAS COMUNES
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900" data-id="element-75">
            ❓ PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-2" data-id="element-76">
          {faqs.map((faq, idx) => <div key={idx} className="border border-slate-200 rounded-2xl overflow-hidden bg-slate-50" data-id="element-77">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-4 text-left focus:outline-none" data-id="element-78">
                <span className="font-bold text-slate-800 pr-4" data-id="element-79">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === idx ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="text-brand-600 shrink-0" data-id="element-80">
                  <ExpandMoreIcon data-id="element-81" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-82">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-83">
                    <div className="px-4 pb-4 text-slate-600 font-medium border-t border-slate-100 pt-3 text-sm" data-id="element-84">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}